module.exports = __webpack_public_path__ + "img/sasvg.a5a2de1d.svg";